import { atom } from "jotai"

import { AuthenticationStatus, CCPMode } from "@/types/modes"

export enum UndocumentedAgentStateType {
  ERROR = "error",
  SYSTEM = "system",
}

export const cognitoAuthStatusAtom = atom<AuthenticationStatus>({
  current: "AUTHENTICATING",
})

export const ccpModeAtom = atom<CCPMode>({ current: "LOADING" })

export const isMutedAtom = atom<boolean>(false)
